export var breakpoints = {
  small: 0,
  medium: 768,
  large: 1024,
  huge: 1280
};
export var defaultBreakpoint = "huge";
export var pageGutterSpace = 2;
export var axAsideWidthSpace = 32.5;
export var touchTargetSizeSpace = 6;
export var animationDuration = {
  "default": 200,
  slow: 400
};
export var minSwipeDistanceOnMobile = 50;
export var pageHeaderTransitionDuration = animationDuration.slow;
export var lowEmphasisOpacity = 0.6;
var pageHeaderZIndex = 8999999; // This value must be higher than #chat-widget-container

export var zIndex = {
  CookieMol: pageHeaderZIndex + 40,
  ModalOrg: pageHeaderZIndex + 30,
  FloatingButtonMol: pageHeaderZIndex + 25,
  AdvancedProductCardMolMobileDetails: pageHeaderZIndex - 20,
  TableMolHeader: pageHeaderZIndex + 1,
  PageHeaderOrgMain: pageHeaderZIndex,
  SelectMolOptions: 40,
  FloatingAside: 30,
  TooltipMolContent: 20,
  ProductSummarySimpleMobileFixedOrg: 10
};
export var headerHeight = 104;
export var headerBottomBarHeight = 60;
export var simpleHeaderDesktopHeightSpace = 9;